import { render, staticRenderFns } from "./ZubehörDialog.vue?vue&type=template&id=e3012d86"
import script from "./ZubehörDialog.vue?vue&type=script&lang=js"
export * from "./ZubehörDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports